var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "vehicle-trip-summary"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Network Trip Summary Report")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Hub Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('HubName')
    },
    attrs: {
      "options": _vm.HubNameData,
      "selected-option": _vm.hubNameObjData,
      "name": "HubName",
      "placeholder": "Select Hub Name"
    },
    on: {
      "select": _vm.selectedHub
    },
    model: {
      value: (_vm.srcHubName),
      callback: function($$v) {
        _vm.srcHubName = $$v
      },
      expression: "srcHubName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('HubName')),
      expression: "errors.has('HubName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('HubName')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubLoading))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Route Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeType),
      expression: "routeType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('routeType')
    },
    attrs: {
      "name": "routeType",
      "id": "routeType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.routeType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.checkRouteType]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Route Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Network")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Local-TP")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('routeType')),
      expression: "errors.has('routeType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('routeType')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Route")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('RouteName')
    },
    attrs: {
      "options": _vm.routenamelist,
      "selected-option": _vm.routenameitem,
      "name": "RouteName",
      "placeholder": "Select Route Name"
    },
    on: {
      "select": _vm.selectRouteName
    },
    model: {
      value: (_vm.routeName),
      callback: function($$v) {
        _vm.routeName = $$v
      },
      expression: "routeName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('RouteName')),
      expression: "errors.has('RouteName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('RouteName')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.routenameLoading))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#1985ac",
      "font-weight": "bold",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.actualRoute))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Current Hub Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.CurrentHubNameData,
      "selected-option": _vm.CurrentHubNameObjData,
      "name": "CurrentHubName",
      "placeholder": "Select Current Hub"
    },
    on: {
      "select": _vm.selectedCurrentHub
    },
    model: {
      value: (_vm.currentHubName),
      callback: function($$v) {
        _vm.currentHubName = $$v
      },
      expression: "currentHubName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vendor Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    attrs: {
      "options": _vm.VendorNameData,
      "selected-option": _vm.vendorNameObjData,
      "name": "vendorName",
      "placeholder": "Select Vendor"
    },
    on: {
      "select": _vm.selectedVendor
    },
    model: {
      value: (_vm.vendorName),
      callback: function($$v) {
        _vm.vendorName = $$v
      },
      expression: "vendorName"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.vendorLoading))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('status')
    },
    attrs: {
      "name": "status",
      "id": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pending"
    }
  }, [_vm._v("Open")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "InProcess"
    }
  }, [_vm._v("InProcess")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Close"
    }
  }, [_vm._v("Close")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'error': _vm.errors.has('FromDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "FromDate"
    },
    on: {
      "change": _vm.checkToDate
    },
    model: {
      value: (_vm.FromDate),
      callback: function($$v) {
        _vm.FromDate = $$v
      },
      expression: "FromDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('FromDate')),
      expression: "errors.has('FromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('FromDate')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("To Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'error': _vm.errors.has('ToDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "ToDate",
      "not-before": _vm.FromDate,
      "not-after": _vm.validDateRange
    },
    model: {
      value: (_vm.ToDate),
      callback: function($$v) {
        _vm.ToDate = $$v
      },
      expression: "ToDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ToDate')),
      expression: "errors.has('ToDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ToDate')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("TripSheet No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripSheetNo),
      expression: "tripSheetNo"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('tripSheetNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter TripSheet No",
      "name": "tripSheetNo",
      "id": "tripSheetNo"
    },
    domProps: {
      "value": (_vm.tripSheetNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tripSheetNo = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin-top": "28px"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")]), _vm._v(" \n                      "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.ExportVehicleTripSummaryForCSV
    }
  }, [_vm._v("Export")])])])])])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTable),
      expression: "showTable"
    }],
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("TripSheet No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Print Trip Sheet")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vehicle No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vendor Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Invoice No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Last Modified By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Modified Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Gate Pass")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.tripSummaryDetails), function(data, index) {
    return [_c('tr', {
      class: {
        opened: _vm.opened.includes(data.thcno)
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "color": "#20a8d8",
        "cursor": "pointer"
      },
      attrs: {
        "title": "View"
      },
      on: {
        "click": function($event) {
          return _vm.getTripDetails(data, index)
        }
      }
    }, [_vm._v(_vm._s(data.thcno))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openRegularPrintModal(data)
        }
      }
    }, [_vm._v("RegularPrint")]), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.printData(data.tripno, data.currenthubid, data.connectionschedulemaster, data.connectionid)
        }
      }
    }, [_vm._v("Print Manifest Consoladated")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.printDataFormCurrentTP(data.tripno, data.currenthubid, data.connectionschedulemaster, data.connectionid)
        }
      }
    }, [_vm._v("Print Manifest")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.printBulkDataFormCurrentTP(data.tripno, data.currenthubid, data.connectionschedulemaster, data.connectionid)
        }
      }
    }, [_vm._v("Print Manifest-I")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vehicleno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vendorname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.invoiceno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.schedulestatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.lastmodifiedby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.lastmodifieddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-print text-successedit fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Print GatePass"
      },
      on: {
        "click": function($event) {
          return _vm.showGatePass(data)
        }
      }
    })])]), _vm._v(" "), (_vm.opened.includes(data.thcno)) ? _c('tr', {
      staticStyle: {
        "background-color": "white"
      },
      attrs: {
        "id": 'flog' + data.thcno
      }
    }, [_c('td', {
      attrs: {
        "colspan": 12
      }
    }, [_c('b-card', {
      staticStyle: {
        "margin": "15px",
        "-webkit-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "-moz-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)"
      }
    }, [_c('div', [_c('br'), _vm._v(" "), _c('legend', {
      staticClass: "header1"
    }, [_vm._v("Vehicle Trip Summary")]), _c('br'), _vm._v(" "), _c('h4', {
      staticClass: "header",
      staticStyle: {
        "margin1-left": "48px",
        "font-family": "Times New Roman, Times, serif",
        "font-size": "18px",
        "color": "#1985ac",
        "margin-left": "5px"
      }
    }, [_vm._v("Actual Route : "), (_vm.VehicleTripDetailsData.length) ? _c('span', [_vm._v(_vm._s(_vm.VehicleTripDetailsData[0].ConnectionName))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "card-body",
      staticStyle: {
        "padding": "0.25rem !important"
      }
    }, [_c('h4', {
      staticClass: "header",
      staticStyle: {
        "margin1-left": "48px",
        "font-family": "Times New Roman, Times, serif",
        "font-size": "18px"
      }
    }, [_vm._v("Vehicle Trip Details")]), _vm._v(" "), _c('vue-element-loading', {
      attrs: {
        "spinner": "line-scale",
        "color": "#FF6700",
        "active": _vm.isLoading
      },
      on: {
        "update:active": function($event) {
          _vm.isLoading = $event
        }
      }
    }), _vm._v(" "), _c('table', {
      staticClass: "table-bordered table",
      staticStyle: {
        "position": "relative",
        "overflow": "auto",
        "font-size": "12px",
        "margin-left1": "49px"
      }
    }, [_c('thead', {
      staticClass: "table table-bordered mytable12 poform_tableheader"
    }, [_c('tr', [_c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px",
        "width": "5%"
      }
    }, [_vm._v("Trip No")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("VendorName")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("VehicleType")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Vehicle No")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Vehicle Capacity Kg.")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Total Load Kg.")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Curr.Load Kg.")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Drv.Name")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Drv.MobileNo")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Reopen")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Reason")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("ReopenVehicle")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.VehicleTripDetailsData), function(tripdata) {
      return _c('tr', [_c('td', {
        staticClass: "text-center",
        staticStyle: {
          "color": "#20a8d8",
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            return _vm.printInvoice(tripdata)
          }
        }
      }, [_vm._v(_vm._s(_vm.thcno))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tripdata.VendorName))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tripdata.VehicleName))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tripdata.VehicleNumber))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tripdata.Capacity * 1000))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(_vm._f("toFixedNum")(tripdata.TotalLoad)))]), _vm._v(" "), (tripdata.CurrentLoad != 0) ? _c('td', {
        staticClass: "text-center"
      }, [_c('span', {
        staticStyle: {
          "color": "blue",
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            return _vm.ShowBagList()
          }
        }
      }, [_vm._v(_vm._s(tripdata.CurrentLoad))])]) : _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tripdata.CurrentLoad))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tripdata.DriverName))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tripdata.DriverMobileNo))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "color": "#20a8d8",
          "cursor": "pointer"
        },
        on: {
          "click": _vm.ReOpenTrip
        }
      }, [_vm._v("ReOpen")]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tripdata.Reason))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "color": "#20a8d8",
          "cursor": "pointer"
        },
        on: {
          "click": _vm.ReOpenVehicle
        }
      }, [_vm._v("ReOpenVehicle")])])
    }), _vm._v(" "), ((_vm.VehicleTripDetailsData && _vm.VehicleTripDetailsData.length == 0) || _vm.VehicleTripDetailsData.length == 0) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "13",
        "align": "center"
      }
    }, [_vm._v("No Data found")])]) : _vm._e()], 2)])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showConnectionLogTable),
        expression: "showConnectionLogTable"
      }],
      staticClass: "card-body",
      staticStyle: {
        "padding": "0.25rem !important background-color: white"
      }
    }, [_c('h4', {
      staticClass: "header",
      staticStyle: {
        "margin1-left": "48px",
        "font-family": "Times New Roman, Times, serif",
        "font-size": "18px"
      }
    }, [_vm._v("Connection Log")]), _vm._v(" "), _c('vue-element-loading', {
      attrs: {
        "spinner": "line-scale",
        "color": "#FF6700",
        "active": _vm.isLoadingSearch
      },
      on: {
        "update:active": function($event) {
          _vm.isLoadingSearch = $event
        }
      }
    }), _vm._v(" "), _c('table', {
      staticClass: "table-bordered table",
      staticStyle: {
        "position": "relative",
        "overflow": "auto",
        "font-size": "12px",
        "margin-left1": "49px"
      }
    }, [_c('thead', {
      staticClass: "table table-bordered mytable12 poform_tableheader"
    }, [_c('tr', [_c('th', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("CSMID")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("Process Location")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("Vehicle Seal No")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("Route Mode Allow Reason")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("CreatedBy")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.ConnectionLogFinalData), function(connectiondata) {
      return _c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(connectiondata.connectionschedulemaster))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(connectiondata.HubName))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(connectiondata.vehiclesealno))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(connectiondata.routemodeallowreason))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(connectiondata.schedulestatus))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(connectiondata.createdby))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(_vm._f("moment")(connectiondata.createddate)))])])
    }), _vm._v(" "), ((_vm.ConnectionLogFinalData && _vm.ConnectionLogFinalData.length == 0) || _vm.ConnectionLogFinalData.length == 0) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "13",
        "align": "center"
      }
    }, [_vm._v("No Data found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('paginate', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.totalRowsNew > 10),
        expression: "totalRowsNew>10"
      }],
      attrs: {
        "page-count": _vm.pageCountLog,
        "page-range": 2,
        "margin-pages": 2,
        "click-handler": _vm.getPaginationDataLog,
        "prev-text": '<<',
        "next-text": '>>',
        "container-class": 'pagination'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "float-left"
    }, [_c('button', {
      staticClass: "common-success-btn",
      on: {
        "click": function($event) {
          return _vm.printData(_vm.thcno, data.currenthubid, data.connectionschedulemaster, data.connectionid)
        }
      }
    }, [_vm._v("Print Invoice")])])], 1)])])], 1)]) : _vm._e()]
  }), _vm._v(" "), ((_vm.tripSummaryDetails && _vm.tripSummaryDetails.length == 0) || _vm.tripSummaryDetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v("No Data found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > 10),
      expression: "totalRows>10"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1)])]), _vm._v(" "), _c('b-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBagListModal),
      expression: "showBagListModal"
    }],
    attrs: {
      "size": "lg",
      "title": "Show Bag List"
    },
    on: {
      "click": function($event) {
        return _vm.closeBagListModal()
      }
    },
    model: {
      value: (_vm.showBagListModal),
      callback: function($$v) {
        _vm.showBagListModal = $$v
      },
      expression: "showBagListModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bag List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeBagListModal()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 radio"
  }, [_c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkType),
      expression: "checkType"
    }],
    attrs: {
      "type": "radio",
      "id": "ecom",
      "name": "checkType",
      "value": "Ecom",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.checkType, "Ecom")
    },
    on: {
      "change": [function($event) {
        _vm.checkType = "Ecom"
      }, function($event) {
        return _vm.onChange($event, 0)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ecom"
    }
  }, [_vm._v("ECOM")]), _c('br')])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkType),
      expression: "checkType"
    }],
    attrs: {
      "type": "radio",
      "id": "cargo",
      "name": "checkType",
      "value": "Cargo"
    },
    domProps: {
      "checked": _vm._q(_vm.checkType, "Cargo")
    },
    on: {
      "change": [function($event) {
        _vm.checkType = "Cargo"
      }, function($event) {
        return _vm.onChange($event, 1)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "cargo"
    }
  }, [_vm._v("CARGO")]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticStyle: {
      "color": "purple",
      "float": "right"
    }
  }, [_vm._v("Total Count:"), _c('b', [_vm._v(" " + _vm._s(_vm.bagCount))])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCSVFileByType(_vm.checkType)
      }
    }
  }, [_vm._v("Export")])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [(_vm.checkType == 'Ecom') ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingBagList
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingBagList = $event
      }
    }
  }), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("BagNo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Source Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent Bag Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("PLS Bag Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Count")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.bags), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.sourcehubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentbagcount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.plsbagcount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shipmentcount))])])
  }), _vm._v(" "), ((_vm.bags && _vm.bags.length == 0) || _vm.bags.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.checkType == 'Cargo') ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingBagList
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingBagList = $event
      }
    }
  }), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ShippingID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Source Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent Bag Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("PLS Bag Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Count")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.shipments), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.sourcehubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("0")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("0")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("0")])])
  }), _vm._v(" "), ((_vm.shipments && _vm.shipments.length == 0) || _vm.shipments.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.bagCount != 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pageCountForBags,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationDataForBagList,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.viewtripmodel = false
      }
    },
    model: {
      value: (_vm.viewtripmodel),
      callback: function($$v) {
        _vm.viewtripmodel = $$v
      },
      expression: "viewtripmodel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(" Print Gate Pass")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideviewtripmodel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.GatePassDetails.length == 0) ? _c('div', [_c('h6', {
    staticStyle: {
      "margin-left": "308px"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), (_vm.GatePassDetails.length > 0) ? _c('div', {
    staticClass: "modal-bodyfrm",
    attrs: {
      "id": "GatePass"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "float": "left"
    }
  }, [_c('span', [_c('b', [_vm._v("Print Date : ")]), _vm._v(_vm._s(_vm._f("moment")(_vm.PrintDate)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', [_c('b', [_vm._v("Print By : ")]), _vm._v(_vm._s(_vm.PrintBy))])])]), _vm._v(" "), _vm._l((_vm.GatePassDetails), function(obj) {
    return _c('table', {
      staticClass: "table table-bordered",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', {
      staticStyle: {
        "background-color": "#b3ecff",
        "height": "39px"
      }
    }, [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticStyle: {
        "margin-left": "310px",
        "font-size": "17px",
        "font-family": "Arial, Helvetica, sans-serif"
      }
    }, [_c('b', [_vm._v("Gate Pass")])])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "#fffefe"
      }
    }, [_c('td', [_c('span', [_c('b', [_vm._v("Hub Center : ")]), _vm._v(_vm._s(obj.currenthub))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Seal Date : ")]), _vm._v(" " + _vm._s(_vm._f("moment")(obj.sealdate)))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_c('b', [_vm._v("Vehicle Type : ")]), _vm._v(" " + _vm._s(obj.vehiclename))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Vehicle Out Time : ")]), _vm._v(" " + _vm._s(obj.vehcileouttime))])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "#fffefe"
      }
    }, [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', [_c('b', [_vm._v("Vendor Name : ")]), _vm._v(" " + _vm._s(obj.vendorname))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_c('b', [_vm._v("Trip Sheet No : ")]), _vm._v(_vm._s(obj.thcno))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Route Name : ")]), _vm._v(" " + _vm._s(obj.connectionname))])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "#fffefe"
      }
    }, [_c('td', [_c('span', [_c('b', [_vm._v("Vehicle# : ")]), _vm._v(" " + _vm._s(obj.vehicleno))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Vehicle Seal No : ")]), _vm._v(" " + _vm._s(obj.vehiclesealno))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_c('b', [_vm._v("Route Mode : ")]), _vm._v(" " + _vm._s(obj.routemode))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Driver Name : ")]), _vm._v(" " + _vm._s(obj.drivername))])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "#fffefe"
      }
    }, [_c('td', [_c('span', [_c('b', [_vm._v("Driver Mobile No : ")]), _vm._v(" " + _vm._s(obj.mobilenumber))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("No Of Bags : ")]), _vm._v(" " + _vm._s(obj.totalocalbag))])])]), _vm._v(" "), _c('tr', {
      attrs: {
        "height": "100px"
      }
    }, [_c('td', [_c('span', [_c('b', [_vm._v("Signature(Origin) : ")]), _vm._v(" " + _vm._s(""))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Name : ")]), _vm._v(" " + _vm._s(""))])])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.GatePassDetails.length > 0) ? _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.printGatePass
    }
  }, [_vm._v("Print")])]) : _vm._e()])])]), _vm._v(" "), (_vm.showModal == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Transactions Log"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Transactions Log")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.transactions), function(data, index) {
    return (_vm.transactions.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.BagNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ProcessLocation))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CurrentLocation))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Process))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Comment))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.CreatedDate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.shippingDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.showPrintModal),
      callback: function($$v) {
        _vm.showPrintModal = $$v
      },
      expression: "showPrintModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Regular Print")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeRegularPrintModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('fieldset', [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingPrintSheet
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPrintSheet = $event
      }
    }
  }), _vm._v(" "), (_vm.tripdatafound == true) ? _c('div', {
    attrs: {
      "id": "regulartripsheetContent"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Print By :")]), _vm._v(" " + _vm._s(_vm.printBy))]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Print Date :")]), _vm._v(" " + _vm._s(_vm.printDate))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Trip Sheet")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Manual THC : ")]), _vm._v(" " + _vm._s(_vm.tripdata.VendorVehicleTripID) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip Start Date: ")]), _vm._v(" " + _vm._s(_vm._f("momentDate")(_vm.tripdata.TripStartTime)) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip End Date: ")]), _vm._v(" " + _vm._s(_vm._f("momentDate")(_vm.tripdata.TripEndTime)) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("THC Entry Time :")]), _vm._v(" " + _vm._s(_vm._f("momentTime")(_vm.tripdata.TripStartTime)) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("THC End Time :")]), _vm._v(" " + _vm._s(_vm._f("momentTime")(_vm.tripdata.TripEndTime)))]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle Type : ")]), _vm._v(" " + _vm._s(_vm.tripdata.VehicleName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vendor Type : ")]), _vm._v(" " + _vm._s(_vm.vendortype))]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vendor Name : ")]), _vm._v(" " + _vm._s(_vm.tripdata.VendorName))]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Current Location : ")]), _vm._v(" " + _vm._s(_vm.currenthub) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Route Name : ")]), _vm._v(" " + _vm._s(_vm.fullConnectionName))]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle : ")]), _vm._v(_vm._s(_vm.tripdata.VehicleNo) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Driver Name : ")]), _vm._v(" "), (_vm.tripdata.DriverDetails.length > 0) ? _c('span', [_vm._v(" " + _vm._s(_vm.tripdata.DriverDetails[0].DriverName))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip Start Km :")]), _vm._v(" "), (_vm.tripdata.ShipmentDetails.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.tripdata.ShipmentDetails[0].CurrentKM) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip End Km : ")]), _vm._v(" "), (_vm.tripdata.ShipmentDetails.length > 1) ? _c('span', [_vm._v(" " + _vm._s(_vm.tripdata.ShipmentDetails[_vm.tripdata.ShipmentDetails.length - 1].CurrentKM))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("No. Of Bags :")]), _vm._v(_vm._s(_vm.shipmentdataLength))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.shipmentdata), function(d, i) {
    return [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      staticStyle: {
        "margin-bottom": "20px"
      },
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "9"
      }
    }, [_c('strong', {
      staticStyle: {
        "font-size": "20px"
      }
    }, [_vm._v("Shipment Information ")])])]), _vm._v(" "), _c('tr', [_c('th', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("ShipmentId/Bag No.")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Type")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("No. of Shipments")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Physical Weight")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Chargeable Weight")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Volumetric Weight")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Origin")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "colspan": "2"
      }
    }, [_c('strong', [_vm._v("Destination")])])]), _vm._v(" "), _vm._l((d), function(data) {
      return _c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.bagtype))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.shipmentcount))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.chargeableweight))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.volumetricweight))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.originhubname))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.groupname))])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.gettotalshipments(d)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.gettotalphywt(d))))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.gettotalcharwt(d))))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.gettotalvolwt(d))))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    })]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-left",
      attrs: {
        "colspan": "2"
      }
    }, [_c('strong', [_vm._v("Total Vol.Wt. :")]), _vm._v(" " + _vm._s(_vm._f("toFixedNum")(_vm.gettotalvolwt(d))))]), _vm._v(" "), _c('td', {
      staticClass: "text-left",
      attrs: {
        "colspan": "2"
      }
    }, [_c('strong', [_vm._v("Total Phy.Wt. :")]), _vm._v(" " + _vm._s(_vm._f("toFixedNum")(_vm.gettotalphywt(d))))]), _vm._v(" "), _c('td', {
      staticClass: "text-left",
      attrs: {
        "colspan": "6"
      }
    }, [_c('strong', [_vm._v("Total Bags : ")]), _vm._v(" " + _vm._s(d.length))])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "valign": "bottom",
        "colspan": "4",
        "rowspan": "7",
        "height": "100"
      }
    }, [_vm._v("Location Incharge Signature(Origin)")]), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "bottom",
        "colspan": "6",
        "rowspan": "7",
        "height": "100"
      }
    }, [_vm._v("Location Incharge Signature(Destination)")])])], 2)])]
  })], 2) : _c('div', [_c('span', [_vm._v("No Data found")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplay),
      expression: "isDisplay"
    }],
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.printGatePass('regularprint')
      }
    }
  }, [_vm._v("Print")])])], 1)]), _vm._v(" "), _c('br')])], 1)])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f5386fe","hasScoped":true}!./src/views/components/VehicleTripSummaryV1/VehicleTripSummaryV1.html
// module id = 1714
// module chunks = 2